import { OAuthComponent } from './oauth/oauth.component';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { JobComponent } from './job/job.component';
import { AboutComponent } from './about/about.component';
import { Activity1710Component } from './activity1710/activity1710.component';
import {
  CanActivateWithLogin, CanActivateChildWithLogin,
  CanActivateByStudent, CanActivateAllRouter, CanActivateTalentRouter
} from './core/services/can-activate-guard';
const routes: Routes = [

  {
    path: '', component: HomeComponent, pathMatch: 'full',
    canActivate: [CanActivateAllRouter], data: { state: 'homep' }
  },
  {
    path: 'home', component: HomeComponent,
    canActivate: [CanActivateAllRouter], data: { state: 'home' }
  },
  {
    path: 'activity1710', component: Activity1710Component
  },
  {
    path: '2017zhaopin', component: Activity1710Component
  },
  {
    path: 'talent', loadChildren: 'app/talent/talent.module#TalentModule',
    canActivate: [CanActivateTalentRouter], data: { state: 'talent' }
  },
  { path: 'job', loadChildren: 'app/job/job.module#JobModule', data: { state: 'job' } },
  { path: 'station', loadChildren: 'app/course/course.module#CourseModule', data: { state: 'station' } },
  { path: 'information', loadChildren: 'app/information/information.module#InformationModule', data: { state: 'information' } },
  { path: 'about/:type', component: AboutComponent },
  {
    path: 'user',
    loadChildren: 'app/user/user.module#UserModule', data: { state: 'user' }
  },
  {
    path: 'user-info', loadChildren: 'app/user-info/user-info.module#UserInfoModule',
    data: { state: 'userInfo' }
  },
  {
    path: 'o-auth',
    component: OAuthComponent,
  },
  {
    path: '**', redirectTo: 'home'
  }
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes)],
//   exports: [RouterModule]
// })
// export class AppRoutingModule { }
export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/app-routing.module.ts